export enum RecurringType {
  //   DAILY = 'daily',
  WEEKLY = 'weekly',
  //   MONTHLY = 'monthly',
  //   YEARLY = 'yearly',
}
